import style from "@style/base/index.scss";

/**
 * 获取设备类型
 * @returns phone pad pc
 */
export const getDevice = () => {
  const sm = Number(style.sm.replace("px", ""));
  const md = Number(style.md.replace("px", ""));
  const width = window.innerWidth;
  if (width >= 0 && width <= sm - 1) {
    return "IPHONE";
  }
  if (width >= sm && width <= md - 1) {
    return "IPAD";
  }
  if (width >= md) {
    return "PC";
  }
};

/**
 * 判断是否为微信浏览器
 */
export function isWeixin() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  return false;
}
